/* @flow weak */
import React from 'react';
import cx from 'classnames';
import CURRENCIES from 'lib/Currencies.js';
import MoneyFormatter from 'lib/MoneyFormatter.js';

import './styles/Money.scss';

// TODO: Payment is US only right now but
// this component idea is to be (or wrap) our currency formatter.
//
// <Money cents="1000" currency="EUR" /> == 10€
// <Money cents="1000" currency="USD" /> == $10
//
const Money = ({ cents, currency = CURRENCIES.USD, displaySeparator = true, className }) => {
  const money = new MoneyFormatter(cents, currency);

  return (
    <span className={cx('Money', className)}>
      <div className="Money-container">
        {money.getPrefix() &&
          <span className="Money-currency Money-currency-prefix">
            {money.getPrefix()}
          </span>
        }

        <span>
          {money.getWhole() &&
            <span className="Money-amount Money-whole">
              {money.getWhole()}
            </span>
          }

          {money.getCents() && displaySeparator &&
            <span className="Money-amount Money-separator">
              {money.getSeparator()}
            </span>
          }

          {money.getCents() &&
            <span className="Money-amount Money-cents">
              {money.getCents()}
            </span>
          }
        </span>

        {money.getSuffix() &&
          <span className="Money-currency Money-currency-suffix">
            {money.getSuffix()}
          </span>
        }
      </div>
    </span>
  );
};

Money.propTypes = {
  cents: React.PropTypes.number.isRequired,
  currency: React.PropTypes.string,
  displaySeparator: React.PropTypes.bool,
};

export default Money;



// WEBPACK FOOTER //
// ./src/payments/components/Money.jsx